import { gql } from '@apollo/client'

export default gql(`
mutation deleteFolders($id: [ID!] $project: String){
    deleteFolders(input: $id project: $project)
}
`)
